import React from 'react';
import {Grid, Skeleton, Stack} from "@mui/material"
import ClassifierMetricsSkeleton from "../qualitycheck/ClassifierMetricsSkeleton"
import TestRunTableSkeleton from "../qualitycheck/TestRunTableSkeleton"

interface CustomModelDetailSkeletonProps {
    classCount?: number
}

// Composed from the same region skeletons the sections render, so the handoff from the loading
// page to the mounted sections never swaps one skeleton shape for another — each region shows one
// skeleton until its content arrives.
function CustomModelDetailSkeleton({classCount}: CustomModelDetailSkeletonProps) {
    return (
        <>
            <Stack direction="row" spacing={2} alignItems="center" sx={{mb: 4}}>
                <Skeleton variant="text" width={280} height={48}/>
            </Stack>
            <Grid container spacing={4}>
                <Grid item xs={12} md={9}>
                    <Stack spacing={3}>
                        {classCount != null && <ClassifierMetricsSkeleton classCount={classCount}/>}
                        <TestRunTableSkeleton/>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Skeleton variant="rounded" height={420}/>
                </Grid>
            </Grid>
        </>
    );
}

export default CustomModelDetailSkeleton;
